import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import { loanManagementUrl, setupManagementUrl } from "../../../config";
import Joyride from "react-joyride"; // Import Joyride
import ActiveLoanReversalForm from "./form";

const base_url = loanManagementUrl.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content:
      "This is the Active Loan reversal, where you can nitiate a reversal of an already active loan and approve or reject it.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content:
      "Use the search bar to find specific loans by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to initiate a new reversal.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content:
      "Select actions to be able to approve or reject a reversal from this dropdown.",
    placement: "left",
  },
];
const ReverseActiveLoan = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride

  const actions = {
    entity: 'Active Loan Reversal',
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Initiate Reversal",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ApproveLoanReversal: {
      key: "ApproveRejectLoanReversal",
      button_name: "Approve Reversal",
      Show_Button: true,
      permission: "ActivatePermission",
      //roleGroupId: [1, 2, 3, 4],
    },
    RejectLoanReversal: {
      key: "ApproveRejectLoanReversal",
      button_name: "Reject Reversal",
      Show_Button: true,
      permission: "ActivatePermission",
      //roleGroupId: [1, 2, 3, 4],
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate","InitiatedBy","ApprovedBy","RejectedBy","RejectedDate","ApprovedDate"],
      objectName: "allReversals",
      parameters: "",
    },
    showStatus:true,
    showMore: {
      search: false,
      min: 0,
      max: 0,
    },
  };

  return (
    <Box m="20px">
      <Joyride
        steps={rightsTourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      {/* Top Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Button
          onClick={() => setRunTour(true)}
          variant="outlined"
          color="primary"
        >
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Loan Reversal Management"
        subtitle="Manage Active Loan Reversals"
        FormComponent={ActiveLoanReversalForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default ReverseActiveLoan;
